module.exports = __webpack_public_path__ + "img/lr4.13549533.png";